<template>
    <div class="cs-tab">
        <div class="cs-card">
            <span class="material-icons-outlined cs-icon">{{ icon }}</span>
            <div class="cs-title">{{ title }}</div>
            <span class="cs-chip">Em breve</span>
            <div class="cs-desc">{{ description }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ComingSoonTab",
    props: {
        title: { type: String, required: true },
        icon: { type: String, default: "hourglass_empty" },
        description: {
            type: String,
            default: "Este módulo estará disponível em breve.",
        },
    },
};
</script>

<style lang="scss" scoped>
.cs-tab {
    padding: 60px 20px;
    display: flex;
    justify-content: center;
}
.cs-card {
    max-width: 420px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}
.cs-icon {
    font-size: 40px !important;
    color: #d9d9d9;
}
.cs-title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    margin-top: 4px;
}
.cs-chip {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #8c8c8c;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 999px;
    padding: 2px 10px;
}
.cs-desc {
    font-size: 13px;
    color: #8c8c8c;
    line-height: 1.5;
    margin-top: 4px;
}
</style>
